import React, { Component, useState, useEffect, useRef } from "react";

import styled from "styled-components";
import { Bold16, LinkStyle } from "../components/common";

import "../bankconnect/bankconnect.scss";
import "../screens/Settings.scss";

import hljs from "highlight.js";
import "highlight.js/styles/hopscotch.css";
import javascript from "highlight.js/lib/languages/javascript";

import { BlueLink } from "../components/common";

hljs.registerLanguage("javascript", javascript);

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const APIMention = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 4px;
  background: #ececec;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

function APIModal(props) {
  const high = useRef();

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
  }, [props.showModal]);

  const escFunction = (e) => {
    if (e.keyCode == "27") props.setModal(false);
  };

  // const highlight = () => {
  //   console.log(high);
  //   if (high && high.current) {
  //     const nodes = high.current.querySelectorAll("pre");
  //     nodes.forEach((node) => {
  //       hljs.highlightBlock(node);
  //     });
  //   }
  // };

  // props.showModal && setTimeout(setCodeWindow(true), 3000);

  return props.data.length != 0 ? (
    <>
      <Header>
        <Bold16></Bold16>
        <APIMention className="toolTipAPI" onClick={() => props.setModal(true)}>
          <img src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/CodeAPI.svg" />

          <span className="toolTipTextAPI">
            View API response for {props.name}
          </span>
        </APIMention>
      </Header>
      <div className={`modal ${props.showModal && "active"}`} id="salary-modal">
        <a
          href="#close"
          className="modal-overlay"
          aria-label="Close"
          onClick={() => props.setModal(false)}
        ></a>
        <div
          className="modal-container "
          style={{
            borderRadius: 4,
            padding: "15px 9px 0 25px",
            // height: "fit-content",
            // overflowY: "scroll",
          }}
        >
          <div className="modal-title APItitle">
            <div style={{ display: "flex", alignItems: "center" }}>
              This can be obtained in an API:{"  "}
              <BlueLink
                as="a"
                href={props.apilink}
                style={{ margin: "0 8px" }}
                target="_blank"
              >
                See in Documentation
              </BlueLink>
            </div>{" "}
            <a
              className="btn btn-clear float-right"
              aria-label="Close"
              onClick={() => props.setModal(false)}
            ></a>
          </div>
          <div className="line"></div>
          {props.showModal && (
            <div
              className="apiModal"
              style={{ height: "fit-content", overflow: "scroll" }}
              ref={high}
              dangerouslySetInnerHTML={{
                __html: "<pre>" + props.code + "</pre>",
              }}
            />
          )}
        </div>
      </div>
    </>
  ) : (
    ""
  );
}

export default APIModal;
